module.exports = __webpack_public_path__ + "img/icon_menu_facebook_darkgrey.013df419.svg";